/* eslint-disable import/no-cycle */
import { createSlice } from '@reduxjs/toolkit';
import { orderingInitialState } from './orderingInitialState';
import { couponExtraReducers, removeCoupon, setCoupon, setCouponCode, setIsNew } from './reducers/coupon';
import {
  removeCustomer,
  setAddCustomerModal,
  setCustomer,
  setCustomerAddressId,
  setCustomerPhoneNumber,
  setCustomerPhoneNumberForSms,
  setEditCustomerModal,
} from './reducers/customer';
import { setFormError } from './reducers/global';
import {
  addItemByInput,
  addMenuItem,
  addMenuItemByTempId,
  removeBasketItems,
  removeFreeItem,
  removeItemByTempId,
  removeOrDecreaseMenuItemByTempId,
  removeOrDecrementItem,
  resetOrdering,
  selectMenuItem,
  selectTopping,
  setDataUpdateOrder,
  setDefaultDescription,
  setDeliveryType,
  setDescription,
  setMultiPayment,
  setNote,
  setPaymentType,
  setPreparationTime,
  setTableNumber,
  setUserReturnOrderItem,
  toggleDetailsVisibility,
} from './reducers/ordering';
import { removeDiscount, setOrderPricing } from './reducers/pricing';

export const orderingSlice = createSlice({
  name: 'ordering',
  initialState: orderingInitialState,
  reducers: {
    // Global Reducers
    setFormError,

    // Pricing Reducers
    setOrderPricing,
    removeDiscount,
    setMultiPayment,

    // Coupon Reducers
    removeCoupon,
    setCoupon,
    setCouponCode,
    setIsNew,

    // Customer Reducers
    removeCustomer,
    setCustomer,
    setCustomerPhoneNumber,
    setAddCustomerModal,
    setEditCustomerModal,
    setCustomerAddressId,
    setCustomerPhoneNumberForSms,

    // Order Reducers
    setDeliveryType,
    resetOrdering,
    selectTopping,
    removeOrDecrementItem,
    selectMenuItem,
    addMenuItem,
    toggleDetailsVisibility,
    addMenuItemByTempId,
    addItemByInput,
    removeOrDecreaseMenuItemByTempId,
    removeItemByTempId,
    setDefaultDescription,
    setPaymentType,
    setDescription,
    removeBasketItems,
    setTableNumber,
    setPreparationTime,
    setDataUpdateOrder,
    setUserReturnOrderItem,
    setNote,

    // coupon free item
    removeFreeItem,
  },
  extraReducers(builder) {
    couponExtraReducers(builder);
  },
});
